import React from 'react'

import { Paper, Box, Typography, Button } from '@material-ui/core'

import * as service from 'service'
import SettingsPenaltyForm from './components/SettingsPenaltyForm'

const SettingsPenalty = () => {
  const [edit, setEdit] = React.useState(false)
  const [penalty, setPenalty] = React.useState()
  const [isLoading, setIsloading] = React.useState(true)

  const handleClickButtonEdit = () => {
    setEdit(true)
  }

  const lastPenalty = async () => {
    setIsloading(true)

    try {
      const responseLastPenalty = await service.recurrence.penalties.get({
        penaltyId: 'last',
      })
      setPenalty(responseLastPenalty.data.penalty)
    } catch (error) {
      if (error.response.status === 404) {
        setPenalty({
          penalty: {
            interestRate: 0,
            fineValue: 0,
            finePercentage: 0,
            gracePeriodDays: 0,
          },
        })
      }
    } finally {
      setIsloading(false)
    }
  }

  React.useEffect(() => {
    lastPenalty()
  }, [])

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Juros e multa</Typography>
        {!edit && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleClickButtonEdit}
          >
            Editar
          </Button>
        )}
      </Box>

      {penalty && !isLoading && (
        <SettingsPenaltyForm
          edit={edit}
          penalty={penalty}
          setEdit={setEdit}
          onEvent={lastPenalty}
        />
      )}
    </Paper>
  )
}

export default SettingsPenalty
